import React from "react";
import { useState } from "react";
import LoadingEffect from "../../components/LoadingEffect";
import { Button, ButtonA } from "../../styles-components/Buttons";
import { Container } from "../../styles-components/Container";
import {
  Column,
  ErrorMessage,
  Form,
  FormHeader,
  Label,
  Row,
  RowOption,
} from "../../styles-components/FormItens";
import { useForm } from "react-hook-form";
import { useCallback } from "react";
import EventConfig from "../../components/EventConfig";
import inputFormat from "../../utils/inputFormat";
import { useEffect } from "react";
import { Item, Items } from "./styles";
import { BsFillTrashFill, BsPencilSquare } from "react-icons/bs";
import { apiProdutoServico, apiSpecialEvent } from "../../services/data";
import UseRedirectView from "../../utils/UseRedirectView";
import { toast } from "react-toastify";
import ToggleSwitch from "../../components/ToggleSwitch";
import { useParams } from "react-router-dom";
import EventConfigEdit from "../../components/EventConfigEdit";

const EditSpecialEvent = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [eventItems, setEventItems] = useState([]);
  const [event, setEvent] = useState({});
  const [editConfig, setEditConfig] = useState(null);
  const [services, setServices] = useState([]);
  const [clients, setClients] = useState([]);
  const { id } = useParams();

  const {
    formState: { errors },
    register,
    watch,
    unregister,
    setValue,
    handleSubmit,
  } = useForm();

  const watchReplace = watch("has_replace");

  const fetchData = async () => {
    await apiProdutoServico
      .index()
      .then((response) => {
        setServices(response.data.data.services);
        setClients(response.data.data.clients);
      })
      .catch(() => toast.error("Algo deu errado entre você é o servidor!"));

    await apiSpecialEvent
      .show(id)
      .then((response) => {
        setEvent(response.data);
        setEventItems([...response.data.configs]);
        setIsLoading(false);
      })
      .catch(() => toast.error("Algo deu errado entre você é o servidor!"));
  };

  const onSubmit = useCallback(
    async (data) => {
      data.items = eventItems;
      await apiSpecialEvent
        .updateWithHistory(id, data)
        .then((response) => {
          if (response.data.data && response.data.data.error) {
            toast.error(response.data.data.message);
          } else {
            toast.success("Evento especial cadastrado com sucesso!");
            UseRedirectView.to("pedidos/eventoespecial/listagem");
          }
        })
        .catch(() => toast.error("Algo deu errado ao inserir!"));
    },
    [eventItems]
  );

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setValue("has_replace", event.replace_meal?.length > 0 ? true : false);
    setValue("has_addition", event?.has_addition ? true : false);
  }, [event]);

  useEffect(() => {
    if (watchReplace !== "" && watchReplace !== undefined) {
      if (!watchReplace) unregister("services_id");
    }
  }, [watchReplace]);

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <Container>
          <FormHeader>
            <h1>Editar Evento Especial</h1>
            <Button
              color="--white"
              backgroundColor="--orange"
              onClick={() =>
                UseRedirectView.to("pedidos/eventoespecial/listagem")
              }
            >
              Voltar
            </Button>
          </FormHeader>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Column>
              <Row>
                <Label htmlFor="title">Titulo:</Label>
                <input
                  {...register("title", {
                    value: event.title,
                    required: { value: true, message: "Informe um titulo!" },
                  })}
                  style={errors.title && { ...inputFormat }}
                />
              </Row>
              {errors.title && (
                <ErrorMessage color="--red">
                  {errors.title.message}
                </ErrorMessage>
              )}
            </Column>
            <Column>
              <Row>
                <Label>Cliente</Label>
                <select
                  {...register("client_id", {
                    value: event.client_id,
                    required: {
                      value: true,
                      message: "Selecione um cliente",
                    },
                  })}
                  style={errors.client_id && { ...inputFormat }}
                >
                  <option></option>
                  {clients.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.razao_social}
                    </option>
                  ))}
                </select>
              </Row>
              {errors.client_id && (
                <ErrorMessage color="--red">
                  {errors.client_id.message}
                </ErrorMessage>
              )}
            </Column>
            <Column>
              <Row>
                <Label htmlFor="place">Local:</Label>
                <input
                  {...register("place", {
                    value: event.place,
                    required: { value: true, message: "Informe um local!" },
                  })}
                  style={errors.place && { ...inputFormat }}
                />
              </Row>
              {errors.place && (
                <ErrorMessage color="--red">
                  {errors.place.message}
                </ErrorMessage>
              )}
            </Column>
            <Column>
              <Row>
                <Label htmlFor="data">Data:</Label>
                <input
                  type="date"
                  {...register("data", {
                    value: event.data,
                    required: { value: true, message: "Informe uma data!" },
                  })}
                  style={errors.data && { ...inputFormat }}
                />
              </Row>
              {errors.data && (
                <ErrorMessage color="--red">{errors.data.message}</ErrorMessage>
              )}
            </Column>
            <RowOption>
              <ToggleSwitch
                register={register}
                name={"has_replace"}
                checked={event.replace_meal?.length > 0 ? true : false}
              />
              <Label>Esse evento substitui alguma refeição?</Label>
            </RowOption>
            {watchReplace && (
              <>
                <RowOption>
                  <ToggleSwitch
                    register={register}
                    name={"has_addition"}
                    checked={event.has_addition ? true : false}
                  />
                  <Label>Esse evento possui acréscimo por refeição?</Label>
                </RowOption>
                <Column>
                  <Row>
                    <Label style={{ width: "auto" }}>
                      Selecione o serviço ou serviços:
                    </Label>
                  </Row>
                  {services.map((service) => (
                    <RowOption key={service.id}>
                      <Label style={{ display: "flex", alignItems: "center" }}>
                        <input
                          {...register("services_id", {
                            required: {
                              value: true,
                              message: "Selecione uma (s) opção!",
                            },
                            setValueAs: (v) => parseInt(v),
                          })}
                          style={errors.services_id && { ...inputFormat }}
                          type="checkbox"
                          value={service.id}
                          defaultChecked={
                            event.replace_meal.find(
                              (item) => item.produto_servico_id === service.id
                            ) != undefined
                              ? true
                              : false
                          }
                        />
                        {service.nome}
                      </Label>
                    </RowOption>
                  ))}
                  {errors.services_id && (
                    <ErrorMessage color="--red">
                      {errors.services_id.message}
                    </ErrorMessage>
                  )}
                </Column>
              </>
            )}
            <EventConfigEdit
              setEventItems={setEventItems}
              eventItems={eventItems}
              config={editConfig}
              setConfig={setEditConfig}
            />
            {eventItems.length > 0 && (
              <Items>
                {eventItems.map((item, index) => (
                  <Item
                    key={item.title + Math.floor(Math.random() * 1000 + 1)}
                    isFirst={index === 0 ? true : false}
                  >
                    <div>
                      <p>
                        <b>{item.title}</b>
                      </p>
                      <p>
                        {item.description
                          .split("\n")
                          .filter((linha) => linha.trim())
                          .map((linha, i) => (
                            <React.Fragment
                              key={i + Math.floor(Math.random() * 1000 + 1)}
                            >
                              {linha}
                              <br />
                            </React.Fragment>
                          ))}
                      </p>
                    </div>
                    <div>
                      {item.id && (
                        <ButtonA
                          as={"button"}
                          color="--white"
                          type="button"
                          backgroundColor="--yellow"
                          onClick={() => setEditConfig(item)}
                          style={{ marginRight: "5px" }}
                        >
                          <BsPencilSquare />
                        </ButtonA>
                      )}
                      <ButtonA
                        as="button"
                        color="--white"
                        type="button"
                        backgroundColor="--red"
                        onClick={() =>
                          setEventItems((prev) =>
                            prev.filter((value) => value.title !== item.title)
                          )
                        }
                      >
                        <BsFillTrashFill />
                      </ButtonA>
                    </div>
                  </Item>
                ))}
              </Items>
            )}
            {eventItems.length > 0 && (
              <Button
                color="--white"
                backgroundColor="--orange"
                align="flex-end"
              >
                Criar
              </Button>
            )}
          </Form>
        </Container>
      )}
    </>
  );
};

export default EditSpecialEvent;
